import { configuration } from "@/config/InstanceConfiguration";
import { FooterMenuItemType } from "~/core/config/InstanceConfiguration";
import CmsPage from "@/pages/CMS/CmsPage.vue"
import { RouteConfig } from 'vue-router';

const regularRoutes = [
  {
    path: '',
    name: "Home",
    component: () => import("@/pages/Home.vue")
  },
  {
    path: "categorie/:categorySlugs+",
    name: "Category",
    component: () => import("@/pages/Category.vue"),
  },
  {
    path: "produit/:productSlug",
    name: "Product",
    component: () => import("@/pages/Product.vue")
  },
  {
    path: "reinitialisation-mot-de-passe",
    name: "ResetPassword",
    component: () => import(  "@/pages/ResetPassword.vue"),
  },
  {
    name: "My-account",
    path: "mon-compte",
    component: () => import(  "@/pages/MyAccount.vue"),
    redirect: "/mon-compte/profil",
    children: [
      {
        path: "profil",
        name: "MyProfile",
        component: () => import(  "@/pages/MyAccount/MyProfile.vue"),
      },
      {
        path: "carnet-d-adresses",
        name: "MyAddresses",
        component: () => import(  "@/pages/MyAccount/Addresses.vue"),
      },
      {
        path: "commandes",
        name: "MyOrders",
        component: () => import(  "@/pages/MyAccount/MyOrders.vue")
      },
      {
        path: "commandes/:orderReference?",
        name: "MyOrderDetails",
        component: () => import(  "@/pages/MyAccount/MyOrder.vue")
      },
      {
        path: "deconnexion",
        name: "LogOut",
        component: () => import(  "@/pages/MyAccount/Logout.vue")
      }
    ]
  },
  {
    path: "commande/merci/:orderReference?",
    name: "CheckoutThankYou",
    component: () => import(  "@/pages/Checkout/ThankYou.vue"),
  },
  {
    path: "contact",
    name: "Contact",
    component: () => import("@/pages/Contact.vue"),
  },
  {
    path: "recherche",
    name: "Search",
    component: () => import(  "@/pages/Search.vue"),
  },
  {
    path: "mon-panier",
    name: "Cart",
    component: () => import(  "@/pages/Cart.vue"),
  },
  {
    path: "prestataires",
    name: "Prestataires",
    component: () => import(  "@/pages/MarketPlace/Prestataires.vue"),
  },
  {
    path: "401",
    name: "Notauthorized",
    component: () => import(  "@/pages/Errors/NotAuthorized.vue"),
  },
  {
    name: "Checkout",
    path: "commande/",
    meta: {layout: "checkout-layout", requireAuth: true},
    component: () => import(  "@/pages/Checkout.vue"),
    redirect: "/commande/livraison",
    children: [
      {
        path: "connexion",
        name: "CheckoutLogin",
        components: {checkout: () => import(  "@/pages/Checkout/Login.vue")},
      },
      {
        path: "livraison",
        name: "CheckoutShipping",
        components: {checkout: () => import(  "@/pages/Checkout/Shipping.vue")},
      },
      {
        path: "paiement",
        name: "CheckoutPayment",
        components: {checkout: () => import(  "@/pages/Checkout/Payment.vue")},
      }
    ],
  },
  {
    path: "commande/paiement/resultat",
    name: "CheckoutPaymentResult",
    meta: {layout: "blank-layout", requireAuth: true},
    component: () => import(  "@/payment/" + process.env.VUE_APP_PAYMENT_OPERATOR + "/pages/Payment-Result.vue"),
  },
  {
    path: "commande/paiement/retour",
    name: "CheckoutPaymentReturn",
    meta: {layout: "blank-layout", requireAuth: true},
    component: () => import(  "@/payment/" + process.env.VUE_APP_PAYMENT_OPERATOR + "/pages/Payment-Return.vue"),
  }
] as RouteConfig[];

const cmsGenericRoutes = [
  ... configuration.footer.menuCol1?.items || [],
  ... configuration.footer.menuCol2?.items || [],
  ... configuration.footer.menuCol3?.items || []
].filter(item => item.type === FooterMenuItemType.GENERIC || !item.type)
.map(item => {
  return {
    name: item.slug,
    path: 'cms/' + item.url,
    component: item.component || CmsPage
}}) as RouteConfig[];

export default [... regularRoutes, ...cmsGenericRoutes]
